import { Component } from "react";
import { connect } from "react-redux";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import CustomLayout from "./containers/Layout";
import Renewpass from "./containers/Renewpass";
import UserLayout from "./containers/UserLayout";
import BaseRouter from "./routes";
import * as actions from "./store/actions/auth";
import { getPermission } from "./store/actions/user";

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/renewpass/:tok" component={Renewpass} />
          <Route exact path="/login" component={UserLayout} />

          <CustomLayout {...this.props}>
            <BaseRouter />
          </CustomLayout>
        </Switch>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    permission: state.user.permission,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
    addPermission: (user) => dispatch(getPermission(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
